"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineAuthenticationQrScanner = exports.AuthenticationQrScanner = void 0;
const html5_qrcode_1 = require("html5-qrcode");
const lib_es2015_1 = require("@hodol/web-component-helper/lib-es2015");
const lib_es2015_2 = require("@hodol/dom-helper/lib-es2015");
class AuthenticationQrScanner extends HTMLElement {
    constructor() {
        super();
        this.elementId = 'reader';
        this.innerHTML = `
      <div class="qr-cotainer" style="margin: var(--main-frame-header-height) auto 0; display: flex; flex-direction: column; align-items: center;">
        <div id="reader" style="width: 100%; max-width: 600px;"></div>
        <div id="result" style="box-sizing: border-box; margin-top: 0.5rem; font-size: 2rem;"></div>
      </div>
    `;
        this.html5QrCode = new html5_qrcode_1.Html5Qrcode('reader');
        this.resultBox = (0, lib_es2015_2.getQuerySelectOrThrowError)(this, 'div#result');
        this.startScanner();
    }
    disconnectedCallback() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.stopScanner();
        });
    }
    startScanner() {
        return __awaiter(this, void 0, void 0, function* () {
            const config = {
                fps: 10, // 초당 프레임 수
                qrbox: { width: 250, height: 250 }, // 스캔 영역 크기
            };
            try {
                // 'environment'는 후면 카메라를 의미합니다.
                yield this.html5QrCode.start({ facingMode: 'environment' }, config, (decodedText, decodedResult) => {
                    // 스캔 성공 시 실행될 콜백
                    this.onScanSuccess(decodedText);
                }, errorMessage => {
                    // 스캔 중 에러 (지속적으로 발생하므로 로깅은 최소화하는 것이 좋음)
                });
            }
            catch (err) {
                console.error('카메라 시작 실패:', err);
            }
        });
    }
    // 스캔 성공 핸들러
    onScanSuccess(decodedText) {
        this.resultBox.innerText = decodedText;
        if (decodedText === 'SUCCESS') {
            this.resultBox.style.setProperty('color', 'green');
        }
        else if (decodedText === 'FAIL') {
            this.resultBox.style.setProperty('color', 'red');
        }
        // 스캔 성공 후 멈추고 싶다면:
        // this.stopScanner();
    }
    // 스캐너 중지
    stopScanner() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.html5QrCode) {
                try {
                    yield this.html5QrCode.stop();
                    console.log('스캐너 중지됨');
                }
                catch (err) {
                    console.error('스캐너 중지 실패:', err);
                }
            }
        });
    }
}
exports.AuthenticationQrScanner = AuthenticationQrScanner;
const defineAuthenticationQrScanner = (name) => {
    (0, lib_es2015_1.defineIfUndefined)(name, AuthenticationQrScanner);
};
exports.defineAuthenticationQrScanner = defineAuthenticationQrScanner;
